import { render, staticRenderFns } from "./shareModel.vue?vue&type=template&id=73daf449&scoped=true&"
import script from "./shareModel.vue?vue&type=script&lang=js&"
export * from "./shareModel.vue?vue&type=script&lang=js&"
import style0 from "./shareModel.vue?vue&type=style&index=0&id=73daf449&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73daf449",
  null
  
)

export default component.exports